import ratnagiri from "../../../assets/images/map/Ratnagiri.jpg";
import nashik from "../../../assets/images/map/Nashik.jpg";
import pune from "../../../assets/images/map/Pune.jpg";
import chhatrapatisambhajinagar from "../../../assets/images/map/Chatrapati Sambhaji Nagar.jpg";
import nanded from "../../../assets/images/map/Nanded.jpg";
import nagpur from "../../../assets/images/map/Nagpur.jpg";

const monumentDivisionData = {
  English: {
    title: "Monuments and Sites",
    breadcrumb: {
      home: "HOME",
      page: "MONUMENTS AND SITES",
    },
    divisionsData: {
      ratanagirimonument: {
        label: "RATNAGIRI DIVISION",
        image: ratnagiri,
        districts: [
          { id: 1, name: "Palghar", count: 2, path: "palghar" },
          { id: 2, name: "Thane", count: 2, path: "thane" },
          { id: 3, name: "Mumbai", count: 10, path: "mumbai" },
          { id: 4, name: "Raigad", count: 6, path: "raigad" },
          { id: 5, name: "Ratnagiri", count: 21, path: "ratnagiri" },
          { id: 6, name: "Sindhudurg", count: 3, path: "sindhudurg" },
        ],
      },
      nashik: {
        label: "NASHIK DIVISION",
        image: nashik,
        districts: [
          { id: 1, name: "Nandurbar", count: 1, path: "nandurbar" },
          { id: 2, name: "Dhule", count: 5, path: "dhule" },
          { id: 3, name: "Jalgaon", count: 6, path: "jalgaon" },
          { id: 4, name: "Ahilyanagar ", count: 12, path: "ahilyanagar" },
          { id: 5, name: "Nashik", count: 28, path: "Nashik" },

        ],
      },
      pune: {
        label: "PUNE DIVISION",
        image: pune,
        districts: [
          { id: 1, name: "Pune", count: 24, path: "pune" },
          { id: 2, name: "Satara", count: 7, path: "satara" },
          { id: 3, name: "Solapur", count: 4, path: "solapur" },
          { id: 4, name: "Sangli", count: 2, path: "sangli" },
          { id: 5, name: "Kolhapur", count: 8, path: "kolhapur" },
        ],
      },
      chhatrapatisambhajinagar: {
        image: chhatrapatisambhajinagar,
        label: "CHHATRAPATI SAMBHAJINAGAR DIVISION",
        districts: [
          { id: 1, name: "Chhatrapati Sambhajinagar", count: 39, path: "sambhajinagar" },
          { id: 2, name: "Jalna", count: 5, path: "jalna" },
          { id: 3, name: "Beed", count: 21, path: "beed" },
          { id: 4, name: "Dharashiv", count: 27, path: "dharashiv" },
        ],
      },
      nanded: {
        label: "NANDED DIVISION",
        image: nanded,
        districts: [
          { id: 1, name: "Parbhani", count: 26, path: "parbhani" },
          { id: 2, name: "Hingoli", count: 13, path: "hingoli" },
          { id: 3, name: "Latur", count: 5, path: "latur" },
          { id: 4, name: "Nanded", count: 33, path: "nanded" },
        ],
      },
      nagpur: {
        label: "NAGPUR DIVISION",
        image: nagpur,
        districts: [
          { id: 1, name: "Buldhana", count: 6, path: "buldhana" },
          { id: 2, name: "Akola", count: 5, path: "akola" },
          { id: 3, name: "Amravati", count: 4, path: "amravati" },
          { id: 4, name: "Washim", count: 4, path: "washim" },
          { id: 5, name: "Nagpur", count: 46, path: "nagpur" },
          { id: 6, name: "Yavatmal", count: 2, path: "yavatmal" },
          { id: 7, name: "Bhandara", count: 3, path: "bhandara" },
          { id: 8, name: "Chandrapur", count: 10, path: "chandrapur" },
          { id: 9, name: "Gondia", count: 1, path: "gondia" },
        ],
      },
    },
  },

  मराठी: {
    title: "स्मारके व पुरास्थळे",
    breadcrumb: {
      home: "मुख्यपृष्ठ ",
      page: "स्मारके व पुरास्थळे",
    },
    divisionsData: {
      ratanagirimonument: {
        label: "रत्नागिरी विभाग",
        image: ratnagiri,
        districts: [
          { id: 1, name: "पालघर", count: "२", path: "palghar" },
          { id: 2, name: "ठाणे", count: "२", path: "thane" },
          { id: 3, name: "मुंबई", count: "१0", path: "mumbai" },
          { id: 4, name: "रायगड", count: "६", path: "raigad" },
          { id: 5, name: "रत्नागिरी", count: "२१", path: "ratnagiri" },
          { id: 6, name: "सिंधुदुर्ग", count: "३", path: "sindhudurg" },
        ],
      },
      nashik: {
        label: "नाशिक विभाग",
        image: nashik,
        districts: [
          { id: 1, name: "नंदुरबार", count: "१", path: "nandurbar" },
          { id: 2, name: "धुळे", count: "५", path: "dhule" },
          { id: 3, name: "नाशिक", count: "२८", path: "Nashik" },
          { id: 4, name: "जळगाव", count: "६", path: "jalgaon" },
          { id: 5, name: "अहिल्यानगर", count: "१२", path: "ahilyanagar" },
        ],
      },
      pune: {
        label: "पुणे विभाग",
        image: pune,
        districts: [
          { id: 1, name: "पुणे", count: "२४", path: "pune" },
          { id: 2, name: "सातारा", count: "७", path: "satara" },
          { id: 3, name: "सोलापूर", count: "४", path: "solapur" },
          { id: 4, name: "सांगली", count: "२", path: "sangli" },
          { id: 5, name: "कोल्हापूर", count: "८", path: "kolhapur" }
        ],
      },
      chhatrapatisambhajinagar: {
        label: "छत्रपती संभाजीनगर विभाग",
        image: chhatrapatisambhajinagar,
        districts: [
          { id: 1, name: "छत्रपती संभाजीनगर", count: "३९", path: "sambhajinagar" },
          { id: 2, name: "जालना", count: "५", path: "jalna" },
          { id: 3, name: "बीड", count: "२१", path: "beed" },
          { id: 4, name: "धाराशिव", count: "२७", path: "dharashiv" },
        ],
      },
      nanded: {
        label: "नांदेड विभाग",
        image: nanded,
        districts: [
          { id: 1, name: "परभणी", count: "२६", path: "parbhani" },
          { id: 2, name: "हिंगोली", count: "७", path: "hingoli" },
          { id: 3, name: "लातूर", count: "५", path: "latur" },
          { id: 4, name: "नांदेड", count: "३३", path: "nanded" },
        ],
      },
      nagpur: {
        label: "नागपूर विभाग",
        image: nagpur,
        districts: [
          { id: 1, name: "बुलढाणा", count: "६", path: "buldhana" },
          { id: 2, name: "अकोला", count: "५", path: "akola" },
          { id: 3, name: "अमरावती", count: "४", path: "amravati" },
          { id: 4, name: "वाशीम", count: "४", path: "washim" },
          { id: 5, name: "नागपूर", count: "४६", path: "nagpur" },
          { id: 6, name: "यवतमाळ", count: "२", path: "yavatmal" },
          { id: 7, name: "भंडारा", count: "३", path: "bhandara" },
          { id: 8, name: "चंद्रपूर", count: "१0", path: "chandrapur" },
          { id: 9, name: "गोंदिया", count: "१", path: "gondia" }
        ],
      },
    },
  },
};

export default monumentDivisionData;
